
import UrlUtil from './url'
import DateUtil from './date'
import { CookieUtil, StoreUtil, CookiePolicyStore } from './cookie'

export const TENANT_ID_MAP = {
  hikvision: 'HIKVISION', // 海康
  micro: 'MICRO' // 微影
}

const getSlideAngle = (dx: number, dy: number): number => {
  return Math.atan2(dy, dx) * 180 / Math.PI
}

const toMinuteSecond = (seconds: number): string => {
  if (!seconds) {
    return '00:00'
  }
  const ONE_HOUR = 60 * 60
  const ONE_MINUTE = 60
  const hours = (seconds - seconds % ONE_HOUR) / ONE_HOUR
  const minutes = (seconds - hours * ONE_HOUR - seconds % ONE_MINUTE) / ONE_MINUTE
  const secs = seconds % 60
  const suffix = `${minutes < 10 ? '0' + minutes : minutes}:${secs < 10 ? '0' + secs : secs}`
  if (hours) {
    return `${hours < 10 ? '0' + hours : hours}:${suffix}`
  }
  return suffix
}

const getSlideDirection = (startX: number, startY: number, endX: number, endY: number): number => {
  const dy = startY - endY
  const dx = endX - startX
  let result = 0
  // 如果滑动距离太短
  if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
    return result
  }
  const angle = getSlideAngle(dx, dy)
  if (angle >= -45 && angle < 45) {
    result = 4
  } else if (angle >= 45 && angle < 135) {
    result = 1
  } else if (angle >= -135 && angle < -45) {
    result = 2
  } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
    result = 3
  }
  return result
}

const toServerUrl = (path: string, isMobile = false) => {
  const win: Window & { prefix?: string } = window
  if (!isMobile) {
    window.location.href = win.prefix ? `/${win.prefix}${path}` : path
  } else {
    window.location.href = win.prefix ? `/${win.prefix}/mobile${path}` : `/mobile${path}`
  }
}

const ellipsis = (str: string, len: number): string => {
  if (!str) {
    return ''
  }
  if (str.length > len) {
    return str.slice(0, len) + '...'
  }
  return str
}

// 从一级路由获取站点code
const getSiteCode = () => {
  const pathes = location.pathname.split('/').filter(Boolean)
  return pathes[0] || ''
}

const login = (target?: string) => {
  const targetString = typeof target === 'string' ? target : ''
  const targetUrl = encodeURIComponent(targetString || (location.pathname + location.search))
  const url = `${window.location.protocol}//${window.location.host}/user/sso/login?target=${targetUrl}`
  // console.log('ON_LOGIN', targetString, url)
  window.location.href = url
}

const logout = () => {
  const url = `${window.location.protocol}//${window.location.host}/user/sso/logout?target=${encodeURIComponent(location.pathname + location.search)}`
  window.location.href = url
}

const deleteAccount = (hikId: string) => {
  const logoutUrl = `${window.location.protocol}//${window.location.host}/user/sso/logout?target=${encodeURIComponent(location.origin)}`
  let host = 'https://cloudsso.hikvision.com'
  const uatUrls = ['elearning-uat', 'elearning-tst']
  if (uatUrls.some(u => location.origin.includes(u))) {
    host = 'https://identity-uat.hikvision.com'
  }
  const url = `${host}/deleteAccount?hikId=${hikId}&logoutUrl=${logoutUrl}`
  window.location.href = url
}

// https://blog.csdn.net/ligang2585116/article/details/44977279

export function shareToFacebook (data: {url: string}) {
  window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(data.url), 'facebook share', 'toolbar=0,status=0')
  return false
}

export function shareToTwitter (data: {url: string, via?: string}) {
  const via = data.via ? data.via : ''
  window.open(`https://twitter.com/intent/tweet?hashtags=Invitedusers&original_referer=${window.location.protocol + '://' + window.location.hostname}&related=domain&text=video&tw_p=tweetbutton&url=` + encodeURIComponent(data.url) + `&via=${via}`, 'share', 'toolbar=0,status=0')
  return false
}

export function shareToLinedin (data: {url: string, lang?: string, token?: string}) {
  const token = data.token ? data.token : ''
  const lang = data.lang ? data.lang : 'en_US'
  window.open(`https://www.linkedin.com/cws/share?url=${encodeURIComponent(data.url)}&token=${token}&isFramed=false&lang=${lang}`, 'Linkedin share', 'toolbar=0,status=0')
  return false
}

// 检查当前站点是否是欧盟站点
export function checkIsEuSite (site: string) {
  const EUSite = ['uk', 'fr', 'es', 'pt']
  return EUSite.includes(site)
}

// 获取租户id
export function getTenantId (url: string) {
  const hikRule = new RegExp(/elearning(-(dev|tst|uat|local))*.hikvision.com/)
  const microRule = new RegExp(/elearning(-(dev|tst|uat|local))*.hikmicrotech.com/)
  if (hikRule.test(url)) {
    return TENANT_ID_MAP.hikvision
  }
  if (microRule.test(url)) {
    return TENANT_ID_MAP.micro
  }
  return TENANT_ID_MAP.hikvision
}

export function getTenantMap () {
  return TENANT_ID_MAP
}

/**
 * 判断是否是生产环境
 */
export function checkIsProduction (url: string) {
  const rule = new RegExp(/elearning.(hikmicrotech|hikvision).com/)
  return rule.test(url)
}

export {
  UrlUtil,
  DateUtil,
  CookieUtil,
  CookiePolicyStore,
  StoreUtil,
  toMinuteSecond,
  toServerUrl,
  getSlideDirection,
  ellipsis,
  getSiteCode,
  login,
  logout,
  deleteAccount
}
